import { NotificationLogoProps } from ".";
import { CustomerLogo } from "@lib/components/MiniComponents/Others";
import { ScannedTransactionPayload } from "@lib/types/Notification";
import { TbZoomMoney } from "react-icons/tb";
import { AppAvatar } from "@lib/components/AppComponents";

export default function ScannedTransactionFoundLogo(
  props: NotificationLogoProps,
) {
  const { notification, onlyIcon = false } = props;
  const payload = notification?.payload as ScannedTransactionPayload;
  const customer = { ...payload?.customer, ...payload?.wallet?.customer };

  if (onlyIcon) {
    return <TbZoomMoney />;
  }

  return (
    <AppAvatar.Group>
      <CustomerLogo customer={customer} />
    </AppAvatar.Group>
  );
}
